export const brandFonts = {
  primary: "'Poppins', sans-serif",
  secondary: "'Butler'",
  tertiary: 'Arial, Helvetica',
};
